import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingReportableAssetId = Brand<number, 'ReportingReportableAssetId'>;
export const ReportingReportableAssetId = createBranded<ReportingReportableAssetId>();
